import React from 'react'

import { Link } from 'react-router-dom'

import { getRecipePathById } from '../Helpers/urls'

class Ingredient extends React.Component {
  propTypes: {
    ingredient: React.PropTypes.object
  }

  render() {
    const ingredient = this.props.ingredient

    let ingredientQuantity = ''
    let ingredientUnits = ''
    let ingredientPrefix = ''
    let ingredientBrand = ''
    let ingredientElement = ''
    let ingredientSuffix = ''

    // Quantity
    if (
      ingredient.quantity &&
      ingredient.quantity !== '' &&
      ingredient.quantity !== '0'
    ) {
      ingredientQuantity = ingredient.quantity + ' '
    }

    // Units
    if (
      ingredient.unitIsPlural &&
      ingredient.unitIsPlural !== false &&
      ingredient.unitsPlural &&
      ingredient.unitsPlural !== ''
    ) {
      ingredientUnits = ingredient.unitsPlural + ' '
    } else if (ingredient.units && ingredient.units !== '') {
      ingredientUnits = ingredient.units + ' '
    }

    // Prefix
    if (ingredient.ingredientPrefix && ingredient.ingredientPrefix !== '') {
      ingredientPrefix = ingredient.ingredientPrefix + ' '
    }

    if (ingredient.brand && ingredient.brand !== '') {
      // Brand
      ingredientBrand = <strong>{ingredient.brand}</strong>
    } else if (ingredient.recipe && ingredient.recipe !== '') {
      // Linked Recipe
      ingredientElement = (
        <Link
          className="link-to-recipe-embedded"
          to={getRecipePathById(ingredient.recipe.uuid)}
        >
          {ingredient.recipe.title}
        </Link>
      )
    } else {
      // Standard Ingredient
      if (
        ingredient.ingredientIsPlural &&
        ingredient.ingredientIsPlural !== false &&
        ingredient.ingredientPlural &&
        ingredient.ingredientPlural !== ''
      ) {
        ingredientElement = <strong>{ingredient.ingredientPlural}</strong>
      } else if (ingredient.ingredient && ingredient.ingredient !== '') {
        ingredientElement = <strong>{ingredient.ingredient}</strong>
      }
    }

    // Suffix
    if (ingredient.ingredientSuffix && ingredient.ingredientSuffix !== '') {
      let space = ''

      if (ingredient.ingredientSuffix.charAt(0) !== ',') {
        space = <React.Fragment>&nbsp;</React.Fragment>
      }

      ingredientSuffix = (
        <React.Fragment>
          {space}
          <span>{ingredient.ingredientSuffix}</span>
        </React.Fragment>
      )
    }

    return (
      <li itemProp="recipeIngredient">
        {ingredientQuantity}
        {ingredientUnits}
        {ingredientPrefix}
        {ingredientBrand}
        {ingredientElement}
        {ingredientSuffix}
      </li>
    )
  }
}

export default Ingredient



// WEBPACK FOOTER //
// ./src/Components/Ingredient.js